module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pedido/pedido.component.scss
// module id = ./src/app/pedido/pedido.component.scss
// module chunks = main